import { createContext, useContext } from 'react';
import { AdminAccess } from '~portal/lib';

/**
 * @desc Everything allowed: what a component rendered outside the admin layout (a story, a unit
 * test of one card) sees. The admin layout always provides the signed-in user's real access.
 */
const UNRESTRICTED: AdminAccess = {
  view: true,
  write: true,
  ario: { read: true, write: true, run: true },
};

const AdminAccessContext = createContext<AdminAccess>(UNRESTRICTED);

/**
 * @desc Provided by the admin layout (`routes/_protected/admin/route.tsx`) from the `users.me`
 * permission claims, via `adminAccessOf` (D21, ADR-29).
 */
export const AdminAccessProvider = AdminAccessContext.Provider;

/**
 * @desc The signed-in user's admin and Ario capabilities inside the admin layout. Admin pages
 * disable their mutating controls unless `write`; Ario pages disable authoring and run controls
 * unless `ario.write` / `ario.run`. UX only — the backend gates (`AVP`, `AP`, `ArioP`) refuse
 * the same calls whatever the page offers.
 */
export function useAdminAccess(): AdminAccess {
  return useContext(AdminAccessContext);
}
